/* @flow */
import { Container } from 'flux/utils';
import * as React from 'react';
import CurrentUser from 'auth/CurrentUser';
import User from 'entities/User';
import AppLayout from 'app/components/AppLayout';

type State = {
  user: ?User,
};

class AppLayoutContainer extends React.Component<$FlowFixMeProps, State> {
  static getStores() {
    return [CurrentUser];
  }

  static calculateState(): State {
    return {
      user: CurrentUser.getUser(),
    };
  }

  render() {
    return <AppLayout user={this.state.user} {...this.props} />;
  }
}

export { AppLayoutContainer };
export default Container.create(AppLayoutContainer, { withProps: true });
